import { ReactNode } from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import AppBreadcrumb from "@/components/AppBreadcrumb";
import CommandPalette from "@/components/CommandPalette";
import { useAuth } from "@/hooks/useAuth";
import EnvironmentBanner from "@/components/EnvironmentBanner";
import StateView from "@/components/StateView";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <StateView
        state="loading"
        className="min-h-screen rounded-none border-none bg-background"
        title="Chargement de la session"
        description="Vérification de vos accès en cours."
      />
    );
  }

  if (!user) {
    return <div>{children}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col w-full bg-background">
      <EnvironmentBanner />
      <div className="flex flex-1">
      <AppSidebar />

      <main className="flex-1 flex flex-col">
        <div className="flex items-center gap-2 border-b border-border px-4 py-2">
          <SidebarTrigger />
          <div className="flex-1 min-w-0">
            <AppBreadcrumb embedded />
          </div>
        </div>

        <div className="flex-1 px-4 py-6 sm:px-6 flex flex-col overflow-hidden">
          {children}
        </div>
      </main>
      </div>

      <CommandPalette />
    </div>
  );
};

export default Layout;
